export enum RootRouteEnum {
  Home = 'home',
  Login = 'login',
  Auth = 'auth',
  Okta = 'okta',
  Dashboard = 'dashboard',
  ResetPassword = 'resetpw',
  VerifyEmail = 'verifyEmail',
  Signup = 'signup',
  Callback = 'callback',

  Analytics = 'analytics',
  Portfolio = 'portfolio',
  Marketplace = 'marketplace',
  SocialMedia = 'social-media',
  GenerativeAI = 'generative-ai',
  WebsiteContent = 'website-content',
  DomainNames = 'domain-names',
  SellerAnalytics = 'seller-analytics',
  SellerIntel = 'seller-intel',
  SellerLink = 'seller-link',
  PriceMonitoring = 'price-monitoring',
  ConversationalAssistant = 'conversational-assistant',
  Settings = 'settings',
}

export enum RiotOktaRouteEnum {
  Okta = 'okta',
  OktaCallback = 'okta-callback',
}

export enum OktaRouteEnum {
  Auth = 'auth',
  Callback = 'callback',
  SamlCallback = 'saml/callback',
}

export enum AnalyticsRouteEnum {
  Performance = 'performance',
  Enforcement = 'enforcement',
  Seller = 'seller',
  Compliance = 'compliance',
  CategoryShare = 'category-share',
  SaturationRate = 'saturation-rate',
  CustomerReports = 'customer-reports',
  SocialMediaVideo = 'social-media-video',
  ComplianceRate = 'compliance-rate',
  CleanlinessRate = 'cleanliness-rate',
  EnforcementAnalysis = 'enforcement-analysis',
  WebsiteContent = 'website-content',
  BrandExposure = 'brand-exposure',
}

export enum PortfolioRouteEnum {
  Assets = 'assets',
  IpDocuments = 'ip-documents',
  CopyrightedImages = 'copyrighted-images',
  InfringingImages = 'infringing-images',
  AuthorizedList = 'authorized-list',
  Models = 'models',
}

export enum MarketplaceRouteEnum {
  Listings = 'listings',
  ReviewNeeded = 'review-needed',
}
export enum MarketplaceListingsRouteEnum {
  Scanned = 'scanned',
  Flagged = 'flagged',

  // in progress
  Requested = 'requested',
  ReportSubmitted = 'report-submitted',
  SoftNotice = 'soft-notice',
  OnHold = 'on-hold',

  // case closed
  Removed = 'removed',
  Denied = 'denied',
  NotEnforceable = 'not-enforceable',
  Dismissed = 'dismissed',

  Archived = 'archived',

  // test purchase
  TestPurchaseReviewing = 'reviewing',
  TestPurchaseDelivery = 'purchase-and-delivery',
  TestPurchaseCompleted = 'completed',
  TestPurchaseCaseClosed = 'case-closed',
}

export enum SocialMediaRouteEnum {
  Listings = 'listings',
  PiracyListings = 'piracy-listings',
  ReviewNeeded = 'review-needed',
}
export enum SocialMediaListingsRouteEnum {
  Scanned = 'scanned',
  Flagged = 'flagged',

  // in progress
  Requested = 'requested',
  ReportSubmitted = 'report-submitted',
  SoftNotice = 'soft-notice',
  OnHold = 'on-hold',

  // case closed
  Removed = 'removed',
  Denied = 'denied',
  NotEnforceable = 'not-enforceable',
  Dismissed = 'dismissed',

  Archived = 'archived',

  // test purchase
  TestPurchaseReviewing = 'reviewing',
  TestPurchaseDelivery = 'purchase-and-delivery',
  TestPurchaseCompleted = 'completed',
  TestPurchaseCaseClosed = 'case-closed',
}

export enum PiracySocialMediaRouteEnum {
  Detected = 'detected',
  Requested = 'requested',
  Reported = 'reported',
  Removed = 'removed',
  Denied = 'denied',
  Dismissed = 'dismissed',
}

export enum GenerativeAIRouteEnum {
  Detected = 'detected',
  Requested = 'requested',
  Reported = 'reported',
  Removed = 'removed',
  Denied = 'denied',
  Dismissed = 'dismissed',
}

export enum WebsiteContentRouteEnum {
  Scanned = 'scanned',
  Flagged = 'flagged',

  // in progress
  Requested = 'requested',
  Reported = 'reported',

  // case closed
  Removed = 'removed',
  Denied = 'denied',
  Dismissed = 'dismissed',

  // test purchase
  TestPurchaseReviewing = 'reviewing',
  TestPurchaseDelivery = 'purchase-and-delivery',
  TestPurchaseCompleted = 'completed',
  TestPurchaseCaseClosed = 'case-closed',
}

export enum DomainNamesRouteEnum {
  Scanned = 'scanned',
  Flagged = 'flagged',

  // in progress
  Requested = 'requested',
  Reported = 'reported',

  // case closed
  Removed = 'removed',
  Denied = 'denied',
  Dismissed = 'dismissed',
  NonEnforceable = 'non-enforceable',

  // watchlist
  Watchlist = 'watchlist',

  // TODO-@blue-poolyum: 추후 삭제 예정
  Monitoring = 'monitoring',
}

export enum ConversationalAssistantRouteEnum {
  Flagged = 'flagged',
  Requested = 'requested',
  Completed = 'completed',
}

export enum PriceMonitoringRouteEnum {
  Monitoring = 'monitoring',
  Analytics = 'analytics',
}

export enum SettingsRouteEnum {
  Account = 'account',
  Billing = 'billing',
  People = 'people',
  Tag = 'tag',
}
